import { Avatar, Group, Stack, Text } from "@mantine/core";

export const fullName = (user) =>
  `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() || user.email;

const SIZES = {
  md: { avatar: "md", name: "sm", email: "xs" },
  lg: { avatar: "lg", name: "md", email: "sm" },
};

// Who an account is, at a glance: picture or initials, name with whatever
// badges matter where it is shown, and the email underneath. `rightSection`
// hangs off the far edge (a role badge, say).
export function AccountIdentity({
  user,
  size = "md",
  badges = null,
  rightSection = null,
}) {
  const sizes = SIZES[size] ?? SIZES.md;
  const name = fullName(user);

  return (
    <Group gap="sm" wrap="nowrap">
      <Avatar
        src={user.picture}
        name={name}
        color="initials"
        radius="xl"
        size={sizes.avatar}
      />
      <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
        <Group gap="xs" wrap="nowrap">
          <Text size={sizes.name} fw={500} truncate>
            {name}
          </Text>
          {badges}
        </Group>
        <Text size={sizes.email} c="dimmed" truncate>
          {user.email}
        </Text>
      </Stack>
      {rightSection}
    </Group>
  );
}
